export default "__VITE_ASSET__DLkNTRW4__"